var _g, _rect, _rect2, _g2, _g3, _g4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgentBuilder = function SvgAgentBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#agent_builder_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.421,
    height: 92.667,
    x: 30,
    y: 43,
    fill: "url(#agent_builder_svg__b)",
    rx: 14.632
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78.035,
    height: 48.772,
    x: 42.193,
    y: 72.263,
    fill: "#F7FBFD",
    rx: 2.439
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76.816,
    height: 47.553,
    x: 42.803,
    y: 72.872,
    stroke: "#68ADFF",
    strokeOpacity: 0.25,
    strokeWidth: 1.219,
    rx: 1.829
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#agent_builder_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    fillRule: "evenodd",
    d: "M52.211 81.062a5.062 5.062 0 0 1 7.16 0l12.151 12.15a5.063 5.063 0 0 1 0 7.161l-12.15 12.151a5.058 5.058 0 0 1-3.58 1.483 5.058 5.058 0 0 1-5.063-5.064 5.062 5.062 0 0 1 1.482-3.58l8.57-8.554-8.562-8.578a5.063 5.063 0 0 1 0-7.16l-.008-.009Zm22.819 27.881a5.064 5.064 0 0 1 5.062-5.062h12.15a5.06 5.06 0 0 1 5.063 5.062 5.062 5.062 0 0 1-5.063 5.063h-12.15a5.06 5.06 0 0 1-5.063-5.063Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#agent_builder_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#agent_builder_svg__e)",
    d: "M104.558 12.947c1.122-2.844 5.147-2.844 6.268 0l5.859 14.854a3.369 3.369 0 0 0 1.898 1.898l14.854 5.859c2.844 1.121 2.844 5.147 0 6.268l-14.854 5.859a3.369 3.369 0 0 0-1.898 1.898l-5.859 14.854c-1.121 2.844-5.146 2.844-6.268 0l-5.859-14.854a3.37 3.37 0 0 0-1.898-1.898l-14.854-5.859c-2.844-1.121-2.844-5.147 0-6.268l14.854-5.859a3.37 3.37 0 0 0 1.898-1.898l5.859-14.854Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#agent_builder_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#agent_builder_svg__g)",
    d: "M24 146c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24 127v-3h-3m-4.5 7.5H18m12 0h1.5m-5.25-.75v1.5m-4.5-1.5v1.5M19.5 127h9a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "agent_builder_svg__a",
    width: 126.807,
    height: 117.052,
    x: 17.807,
    y: 33.246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.439
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.096
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.360784 0 0 0 0 0.564706 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10144_39618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10144_39618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "agent_builder_svg__c",
    width: 58.77,
    height: 46.621,
    x: 44.632,
    y: 75.921,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.439
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.048
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10144_39618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10144_39618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "agent_builder_svg__d",
    width: 71.756,
    height: 71.757,
    x: 71.814,
    y: 4.813,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10144_39618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10144_39618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "agent_builder_svg__f",
    width: 40.059,
    height: 40.059,
    x: 5.985,
    y: 111.985,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.015,
    dy: 2.015
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.015
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10144_39618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10144_39618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agent_builder_svg__b",
    x1: 81.21,
    x2: 81.21,
    y1: 43,
    y2: 135.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5386BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agent_builder_svg__e",
    x1: 90.977,
    x2: 124.931,
    y1: 22.172,
    y2: 60.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D2B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agent_builder_svg__g",
    x1: 24,
    x2: 24,
    y1: 114,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB03"
  })))));
};
export default SvgAgentBuilder;